import { StatusCodes } from 'http-status-codes';
import React, { useEffect, useState } from 'react';
import { QuantityGetDto } from 'svila-common';
import { useHistory } from 'react-router-dom';

import DisplayQuantities from '~/src/components/common/DisplayQuantities';
import ButtonComponent from '~/src/components/common/forms/Button/ButtonComponent';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import FnbApi from '~/src/services/api/FnbApi';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';

export default function FnbHangingOrders(): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);
  const [products, setProducts] = useState<Record<string, QuantityGetDto[]>>({});
  const history = useHistory();

  const getMatchings = async (): Promise<void> => {
    setLoading(true);
    const res = await FnbApi.getHanging();
    if (res.status === StatusCodes.OK) {
      const orderIdsMultple = res.data.map((x) => x.sellOrder.orderNumber);
      const orderIds = [...new Set(orderIdsMultple)];
      const data: Record<string, QuantityGetDto[]> = {};
      orderIds.forEach((orderId) => {
        const q = res.data.filter((x) => x.sellOrder.orderNumber == orderId);
        data[orderId] = q;
      });
      setProducts(data);
    }
    setLoading(false);
  };

  const RenderOrders = () =>
    Object.keys(products)?.map((key) => {
      return (
        <div>
          <h1>{key}</h1>

          <table>
            {products[key]?.map((item) => (
              <tr>
                <td>
                  <DisplayQuantities
                    duQuantity={item.fullDuUnits}
                    dpQuantity={item.singleDpUnits}
                    cuQuantity={item.singleCuUnits}
                  />{' '}
                  {item.product.genericProduct.name}
                </td>
              </tr>
            ))}
          </table>
        </div>
      );
    });

  return (
    <WhitePad>
      <TitleComponent
        title="Hanging orders and their quantities"
        onLeftHandler={() => {
          history.push(`/data-operations`);
        }}
      />
      <PrimaryButton title="Get" onClick={getMatchings} />
      {loading ? <div>yes</div> : <div>{RenderOrders()}</div>}
    </WhitePad>
  );
}
